import React from 'react';
import { ArrowIcon } from '@components-library/Icons/iconsComponents';
import cn from 'classnames';

interface ITabListScrollButtonRightProps {
  handleScroll: (direction: 'right') => void;
  showButton: boolean;
  hidden?: boolean;
}

export const TabListScrollButtonRight = ({
  handleScroll,
  showButton,
  hidden = false,
}: ITabListScrollButtonRightProps) => {
  if (hidden) {
    return;
  }
  return (
    <>
      {showButton && (
        <button
          className={cn('tab-list__scrooll-button', { 'tab-list__scrooll-button_hidden': hidden })}
          onClick={() => handleScroll('right')}>
          <ArrowIcon direction="right" />
        </button>
      )}
    </>
  );
};
